import {
  AIStarsIcon,
  Disclaimer,
  Div,
  H3,
  Img,
  LoadingDots,
  Modal,
  P,
  importMenuImage,
  lightTheme,
} from '@vgrubs/components';
import React from 'react';
import { AIStarsIllustration } from '../MenuAIImprove/menuAiGlow.styled';
import { ProgressBarBackground, ProgressBarFill } from '../MenyStyled';

/**
 * `glow` marks the AI flow (it's only ever passed from the AI import) — it
 * swaps the menu illustration for the AI mark and the copy for "Generating",
 * on top of the modal's gradient-glow treatment.
 */
export const ImportLoaderModal = ({
  loading,
  setLoading,
  loadProgress,
  progress = false,
  glow = false,
}: {
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  loadProgress?: number;
  progress?: boolean;
  glow?: boolean;
}) => {
  return (
    <Modal
      exitButton={false}
      logo={false}
      isOpen={loading}
      width={'450px'}
      closeModal={() => setLoading(true)}
      glow={glow}
    >
      {glow ? (
        <Div $mt="32" $mb="40">
          <AIStarsIllustration $size="120px">
            <AIStarsIcon />
          </AIStarsIllustration>
        </Div>
      ) : (
        <Img alt="" src={importMenuImage} $width="250px" $mb="16" />
      )}
      <H3 $mb="12" $spanColor={lightTheme.darkGray}>
        {glow ? 'Menu is generating' : 'Menu is importing'}
        <LoadingDots active={loading} />
      </H3>
      <P $mb="24">
        {glow
          ? 'The menu is generating. This may take a few minutes. Please be patient.'
          : 'The menu is importing. This may take a few minutes. Please be patient.'}
      </P>
      {progress && (
        <>
          <ProgressBarBackground>
            <ProgressBarFill progress={loadProgress} />
          </ProgressBarBackground>
          <Disclaimer $m="0" $mt="8" $center>
            {loadProgress}%
          </Disclaimer>
        </>
      )}
    </Modal>
  );
};
